import styled from 'styled-components';
import overlayIllustration from 'assets/illustrations/overlay.svg';

export const Wrapper = styled.div`
  padding-bottom: 4rem;
  background-image: url(${overlayIllustration});
  background-size: contain;
  background-position: right top;
  background-repeat: no-repeat;

  @media (max-width: 960px) {
    padding-bottom: 0;
  }
`;

export const IntroWrapper = styled.div`
  padding: 4rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 960px) {
    flex-direction: column;
    padding-bottom: 0;
  }
`;

export const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 960px) {
    width: 100%;
    margin-bottom: 2rem;
  }

  h1 {
    margin-bottom: 2rem;
    font-size: 36pt;
    color: ${({ theme }) => (theme === 'light' ? '#212121' : '#fff')};

    mix-blend-mode: ${({ theme }) => (theme === 'light' ? 'unset' : 'difference')};

    @media (max-width: 680px) {
      font-size: 30pt;
    }
  }

  h4 {
    margin-bottom: 2.5rem;
    font-size: 32pt;
    font-weight: normal;
    color: ${({ theme }) => (theme === 'light' ? '#707070' : '#e6e6e6')};

    mix-blend-mode: ${({ theme }) => (theme === 'light' ? 'unset' : 'difference')};

    @media (max-width: 680px) {
      font-size: 26pt;
    }
  }

  h5 {
    margin-top: 3.5rem;
    font-size: 16pt;
    font-weight: normal;
    color: ${({ theme }) => (theme === 'light' ? '#707070' : '#e6e6e6')};
    mix-blend-mode: ${({ theme }) => (theme === 'light' ? 'unset' : 'difference')};

    @media (max-width: 960px) {
      margin-bottom: 0;
    }

    @media (max-width: 680px) {
      font-size: 12pt;
    }
  }
`;

export const Thumbnail = styled.div`
  flex: 1;

  @media (max-width: 960px) {
    width: 100%;
  }

  img {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  max-width: 70%;
  justify-content: space-between;

  @media (max-width: 960px) {
    flex-direction: column;
    width: 15rem;

    a:first-of-type {
      margin-bottom: 1rem;
    }
  }
`;
